import { db } from '../../firebase/config'
import { client } from '../../hooks/Client'

// Split an array into equally sized chunks (last chunk may be smaller).
const chunk = (arr, size = 10) => {
    const out = []
    for (let i = 0; i < arr.length; i += size) out.push(arr.slice(i, i + size))
    return out
}

// One-shot fetch of MeasureMoments for N researchIds.
// Chunks in 10s to respect Firestore's `in` limit.
const fetchMeasureMomentsForResearches = async (researchIds) => {
    if (!Array.isArray(researchIds) || researchIds.length === 0) return []

    const chunks = chunk(researchIds.filter(Boolean), 10)
    const snaps = await Promise.all(
        chunks.map((c) =>
            db
                .collection('MeasureMoments')
                .where('CompagnyID', '==', client)
                .where('ResearchID', 'in', c)
                .get()
        )
    )

    const seen = new Set()
    const out = []
    snaps.forEach((snap) => {
        snap.docs.forEach((d) => {
            const data = { ...d.data(), docid: d.id }
            if (data.Deleted) return // soft-deleted (ADR-008)
            const id = data.ID || d.id
            if (!seen.has(id)) {
                seen.add(id)
                out.push(data)
            }
        })
    })
    return out
}

export default fetchMeasureMomentsForResearches
